/**
 * Transaction Details model. Inherits SharedPanel object to share expandable panel behavior.
 * @author Tim Sullivan
 *
 */

import Backbone from 'backbone';
import SharedPanel from 'model/activity/sharedPanel';

let DetailsModel = SharedPanel.extend({
	urlRoot: function() {
		if (this.get('transactionType') === 'moneyRequest') {
			return Backbone.history.options.root + 'transaction/money-requests/inline/' + this.get('groupRequestId') + '/details';
		} else if (this.get('transactionType') === 'order') {
			return Backbone.history.options.root + 'transaction/orders/inline';
		} /* else if (this.get('transactionType') === 'checkCapture') {
			return Backbone.history.options.root + 'transaction/details/inline';
		}*/

		return Backbone.history.options.root + 'transaction/details/inline';
	},
	url: function() {
		if (this.get('transactionType') === 'checkCapture') {
			return this.urlRoot() + '/' + this.id + '?checkCapture=true';
		}

		return this.urlRoot() + '/' + this.id;

	}
});

export default DetailsModel;



// WEBPACK FOOTER //
// ./model/txndetails/modules.es6